import { Injectable } from '@angular/core';

import { Action, State, StateContext } from '@ngxs/store';

import { AlternativeService } from '../../services';
import { AlternativeActions } from './alternative.actions';
import { PROJECT_ALTERNATIVE_STATE_TOKEN } from './alternative.model';

@State<string | null>({
  name: PROJECT_ALTERNATIVE_STATE_TOKEN,
  defaults: '',
})
@Injectable()
export class ProjectAlternativeState {
  constructor(private alternativeService: AlternativeService) {}

  @Action(AlternativeActions.SetSelected)
  setSelectedAlternativeUuid(ctx: StateContext<string | null>, { alternativeUuid }: AlternativeActions.SetSelected) {
    ctx.setState(alternativeUuid);
  }

  @Action(AlternativeActions.Confirm)
  confirm(ctx: StateContext<string>, { projectId, selectionId, alternativeUuid }: AlternativeActions.Confirm) {
    return this.alternativeService.confirmQuoteAlternative(projectId, selectionId, alternativeUuid);
  }
}
